import React from 'react';
import { Field, reduxForm } from 'redux-form';
import AnimatedButton from 'common/components/animated_button';
import { PasswordInputField, DEFAULT_REQUIRED_MESSAGE } from 'common/components/form_fields';
import { validatePwdStrength } from 'common/utils';

const ResetForm = ({error, handleSubmit, submitting, submitFailed}) => (
  <form onSubmit={handleSubmit} noValidate>
    <fieldset>
      <Field name="password" label="Password" indicateStrength={true}
             component={PasswordInputField} showVisibilityToggle={true}/>
    </fieldset>

    <AnimatedButton processing={submitting} type="submit" label="Save new password"
      processingLabel="Sending..." errorMsg={error || submitFailed}
      successMsg="Link Sent!" baseBtnClass="btn-tertiary btn-block"/>
  </form>
)

const validate = values => {
  const errors = {}

  if (!values['password']) errors['password'] = DEFAULT_REQUIRED_MESSAGE

  /* validate password strength */
  if (!errors['password']) {
    errors['password'] = validatePwdStrength(values['password'])
  }

  return errors
}

export default reduxForm({
  form: "PasswordResetForm",
  validate,
})(ResetForm);



// WEBPACK FOOTER //
// ./login/components/password_reset_form.jsx